import { useTranslation } from "react-i18next";
import LinePlot from "../charts/LinePlot";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import NumericStatsPanel from "./NumericStatsPanel";
import CategoricalStatsPanel from "./CategoricalStatsPanel";

export default function Bloc1BlockSection({
  id,
  title,
  description,
  charts = null,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const phStats = itemsByField["bloc1.phLevel"]?.stats || null;
  const soilStats = itemsByField["bloc1.soilType"]?.stats || null;
  const phSeries = charts?.phSeries || [];
  const soilChartItems = (soilStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));
  const phBinsChartItems = (phStats?.bins || []).map((bin) => ({
    category: bin.label,
    count: bin.count,
  }));

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc1.loading", "Carregant estadístiques de bloc1…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <NumericStatsPanel
            title={t("dashboard.blocks.bloc1.soilPh", "pH del sòl")}
            stats={phStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc1.soilType", "Tipologia del sòl")}
            stats={soilStats}
            totalLabel={t("dashboard.stats.totalResponses", "Total de respostes")}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <LinePlot
            title={t("dashboard.blocks.bloc1.phTrend", "Evolució temporal del pH")}
            points={phSeries}
            yLabel="pH"
          />

          <BarPlot
            title={t(
              "dashboard.blocks.bloc1.soilTypeDistribution",
              "Distribució de tipologies de sòl"
            )}
            items={soilChartItems}
          />
        </div>

        {!!phBinsChartItems.length && (
          <div className="grid grid-cols-1">
            <BarPlot
              title={t(
                "dashboard.blocks.bloc1.simplePhDistribution",
                "Distribució simple del pH"
              )}
              items={phBinsChartItems}
            />
          </div>
        )}

        {!phBinsChartItems.length && (
          <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-4">
            <div className="text-sm font-medium text-slate-900">
              {t(
                "dashboard.blocks.bloc1.simplePhDistribution",
                "Distribució simple del pH"
              )}
            </div>
            <div className="text-sm text-slate-500 mt-2">
              {t("dashboard.stats.noDistribution", "Sense distribució disponible.")}
            </div>
          </div>
        )}
      </div>
    </DashboardBlockShell>
  );
}
